import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SalesResponseModel } from '@/types/clarityLens/response/salesLens'

export const getSales = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemGroupName: string,
  size: string,
  temperature: string
): Promise<SalesResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/daily-sales-lens/sales`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        branch_names: branchName,
        item_group_name: itemGroupName,
        ...(size !== 'all' && {
          size: size.charAt(0).toUpperCase() + size.slice(1),
        }),
        ...(temperature !== 'all' && {
          style: temperature.charAt(0).toUpperCase() + temperature.slice(1),
        }),
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
